
export const daysBetween = (date) => {
  if (!date) return 9999;
  const now = new Date();
  const target = new Date(date);
  return Math.floor((now - target) / (1000 * 60 * 60 * 24));
};

export const sortAndFilterQuestions = (questions, sortBy) => {
  let data = [...questions];

  switch (sortBy) {
    case "new":
      return data.filter(q =>
        daysBetween(q.created_at) <= 10
      );

    case "active":
      return data.filter(q => {
        const lastActivity =
          q.last_activity_at || q.updated_at || q.created_at;
        return daysBetween(lastActivity) <= 7;
      });

    case "unanswered":
      return data.filter(q =>
        Number(q.answers_count) === 0
      );

    default:
      return data.sort(
        (a, b) =>
          new Date(b.created_at) - new Date(a.created_at)
      );
  }
};

export const getEmptyStateMessage = (type) => {
  switch (type) {
    case "new":
      return "No new questions available.";
    case "active":
      return "No active discussions at the moment.";
    case "unanswered":
      return "No unanswered questions.";
    case "archived":
      return "No archived questions.";
    default:
      return "No questions found.";
  }
};
